import { render } from "./BridgeClock.vue?vue&type=template&id=51ebb0b3&scoped=true"
import script from "./BridgeClock.vue?vue&type=script&lang=js"
export * from "./BridgeClock.vue?vue&type=script&lang=js"

import "./BridgeClock.vue?vue&type=style&index=0&id=51ebb0b3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ebb0b3"]])

export default __exports__